import * as React from "react";

//import scss
import "./style.scss";

import LoaderImage from "../../assets/images/excelforce-logo-only.png"
const Loader = (props) => <div className="__loader" id={props.id}><img src={LoaderImage} /></div>;

export default Loader;
